import React from "react";

import { getStaticAssetURL } from "@lib/getStaticAssetURL";

const MediaMarktLogo = props => (
  <img
    width={40}
    height={40}
    {...props}
    src={getStaticAssetURL(`/images/testDrive/ami_mediamarkt_logo.png`)}
  />
);

export default MediaMarktLogo;
